import { Container } from '@/atoms';
import { CardBlog } from '@/molecules';
import CardsPagination from '@/organisms/cards-pagination';
import { DynamicComponents } from '@/templates';

import { config } from '@/config';
import { getBlogList } from '@/graphql/queries/getBlogList';
import { getPage } from '@/graphql/queries/getPage';
import { dynamicComponentsTransformer } from '@/graphql/transformers';
import { getRealUrl } from '@/utils';
import { getImageWithFallBackWithOutAlt } from '@/utils/utils';

const Blog = ({ page: { attributes, posts } }: any) => (
  <>
    {attributes?.Content?.map(
      ({ __typename, ...props }: any, index: number) => (
        <DynamicComponents
          type={__typename}
          {...props}
          key={`${__typename}-${index}`}
        />
      ),
    )}

    <Container wrapper>
      <CardsPagination>
        {posts?.map((itm: any, index: number) => (
          <CardBlog
            key={`BlogPost-${index}`}
            image={{
              alt: itm?.post?.ImagenPrincipal?.alternativeText || itm.Titulo,
              src: getImageWithFallBackWithOutAlt(
                getRealUrl(itm?.post?.ImagenPrincipal?.url),
                config.fallbackImage,
              ),
            }}
            title={itm.Titulo}
            description={itm.Descripcion}
            tag={itm.post.category.category}
            link={{
              label: 'Saber más',
              href: itm.slug,
            }}
            className="h-full"
          />
        ))}
      </CardsPagination>
    </Container>
  </>
);

export const getStaticProps = async () => {
  const { pages, menus, preFooter, hasCustomFooter, footerStyle, stickyMenu } =
    await getPage('/blog');
  const { blogPosts } = await getBlogList();
  const attributes = pages?.[0] || null;

  if (attributes?.Content)
    attributes.Content = dynamicComponentsTransformer(attributes.Content);

  return {
    props: {
      page: {
        theme: 'light',
        langcode: {
          id: 'es',
        },
        attributes,
        posts: blogPosts,
        menu: menus || [],
        preFooter: preFooter || null,
        hasCustomFooter,
        footerStyle,
        stickyMenu,
      },
    },
    revalidate: process.env.NEXT_PUBLIC_REVALIDATE
      ? parseInt(process.env.NEXT_PUBLIC_REVALIDATE)
      : 1000,
  };
};

export default Blog;
